import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { getAdminToken, clearAdminToken, authFetch } from "../utils/adminAuth";

// Wraps admin pages — verifies the stored JWT by calling /api/admin/me.
// While verifying: shows a spinner. If token invalid/missing: redirect to /admin/login.
const AdminProtectedRoute = ({ children }) => {
  const [status, setStatus] = useState("checking"); // checking | ok | unauth

  useEffect(() => {
    let cancelled = false;
    const verify = async () => {
      const token = getAdminToken();
      if (!token) {
        if (!cancelled) setStatus("unauth");
        return;
      }
      try {
        const resp = await authFetch("/api/admin/me");
        if (cancelled) return;
        if (resp.ok) {
          setStatus("ok");
        } else {
          clearAdminToken();
          setStatus("unauth");
        }
      } catch {
        if (!cancelled) setStatus("unauth");
      }
    };
    verify();
    return () => {
      cancelled = true;
    };
  }, []);

  if (status === "checking") {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-slate-950"
        data-testid="admin-auth-checking"
      >
        <Loader2 className="w-6 h-6 text-indigo-400 animate-spin" />
      </div>
    );
  }
  if (status === "unauth") {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

export default AdminProtectedRoute;
